import { PriceCoreBase } from "./price.core.base"


export class PriceCore extends PriceCoreBase {

}